<template>
  <div class="notice-list">
    <associationNotice @changePage="changePage" @click="toDetails" :list="notice" :total="noticeTotal" v-loading="loading"></associationNotice>
  </div>
</template>

<script>
import associationNotice from '@/components/associationNotice.vue'
import {mapMutations} from 'vuex'
import {findRoute} from '@/utils/routerHelper.js'
import {dynamics} from '@/api/api.js';
export default {
  components:{
    associationNotice
  },
  data(){
    return {
      loading:false,
      notice:[],
      noticeTotal:0,
      currentPage:1
    }
  },
  created(){
    this.getList()
  },
  methods:{
    ...mapMutations('routerData',['changeRouterList']),
     getList(){
      dynamics({
        current:this.currentPage,
        size:10,
        type:14
      }).then(res=>{
        if(res.data.code==200){
          this.noticeTotal=res.data.data.total
          this.notice=res.data.data.records.map(v=>{
            let dateData=this.getDate(v.createTime)
            v.date=dateData.newDates,
            v.day=dateData.day
            return v
          })
        }
      })
    },
    toDetails(data){
      this.$router.push(
        { path: '/associationNews/details',query: { id: data.id } }
      )
      let routerList=[]
      let routers = ['/specialColumn','specialColumnPilotProject', '/associationNews/details'];
      for (let i = 0; i < routers.length; i++) {
        let routerData=findRoute(this.$router.options.routes, routers[i])
         routerList.push(routerData)
      }
      this.changeRouterList(routerList)
    },
    changePage(page){
      this.currentPage=page
      this.getInfo()
    },
    getDate(dateString){
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      return {
        day,
        newDates:year+'-'+(month<10?('0'+month):month)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.notice-list {
  width: 100%;
}
</style>
